import React from 'react';
import LoadingBar from 'react-top-loading-bar'

const LoadingTop = () => {
  return (
    <LoadingBar 
      progress={100}
      color="#279F55"
      loaderSpeed={1500}
      waitingTime={1750}
    />
  )
}

export default LoadingTop
